import {
  WEBSOCKET_CONNECT,
  WEBSOCKET_DISCONNECT
} from '@giantmachines/redux-websocket';
import { RSAA } from 'redux-api-middleware';

const connectSocket = ticket => {
  const baseWSUrl = '/ws/rtc/';
  const host = process.env['REACT_APP_DOMAIN'];
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const url = `${protocol}//${host}${baseWSUrl}?ticket=${ticket}`;
  return {
    type: WEBSOCKET_CONNECT,
    payload: {
      url: url
    }
  };
};

export const disconnectSocket = () => {
  return {
    type: WEBSOCKET_DISCONNECT
  };
};

export const RTC_TICKET_REQUEST = '@@rtc/RTC_TICKET_REQUEST';
export const RTC_TICKET_SUCCESS = '@@rtc/RTC_TICKET_SUCCESS';
export const RTC_TICKET_FAILURE = '@@rtc/RTC_TICKET_FAILURE';
const getChatTicket = () => {
  return {
    [RSAA]: {
      endpoint: `/api/rtc_ticket/`,
      method: 'GET',
      types: [RTC_TICKET_REQUEST, RTC_TICKET_SUCCESS, RTC_TICKET_FAILURE]
    }
  };
};

export const renewRtcTicketAndCreateSocket = () => {
  return async (dispatch, getState) => {
    const state = getState();
    if (!state.auth.token) {
      // do not renew if not authorized anymore
      return Promise.resolve();
    }
    const action = await dispatch(getChatTicket());
    if (!action) {
      // Ticket refresh failed and action is undefined
      return Promise.reject();
    }
    if (action.error) {
      // Promise flow received action error
      return Promise.reject();
    }
    dispatch(connectSocket(action.payload.ticket));
    return Promise.resolve();
  };
};
